
import Rewards from "../pages/Rewards";
import Home from "../pages/Home";
import Videos from "../pages/Videos";
import Sections from "../pages/Sections";
import Quizes from "../pages/Quizes";
import Modules from "../pages/Modules";
import MegnetsVideos from "../pages/MegnetsVideos";
import ManagePrice from "../pages/ManagePrice";
import AllQuestions from "../pages/AllQuestions";
import UserStats from "../Components/UsersStats";
import DiscountedUsers from "../Components/DiscountedUsers";
import FinanceInsights from "../Components/FinancePage";
import UsersTracking from "../pages/UsersTracking";
import TrackLead from "../pages/TrackLead";
import ManageUsers from "../pages/ManageUsers";
import DepositsTracking from "../pages/Deposits";
import PaypalDiscountLink from "../pages/PayaplDiscountLink";
import SourceAcquisition from "../pages/SourceAquisition";
import SalesByCommercial from "../pages/SalesByCommercials";
// import Coupons from "../pages/Coupons";
import CheckoutDiscountLink from "../pages/CheckoutDiscountLink";
import MasterclassStats from "../pages/MasterclassStats";
import MasterclassUsers from "../pages/MasterclassUsers";
import AIToolsTable from "../pages/AIToolsTable";
import Kanban from "../pages/Kanban";
import Leads from "../pages/Leads";
import AddAITemplates from "../pages/AddAITemplates";
import AddAIPrompts from "../pages/AddAIPrompts";
import AITemplatesView from "../pages/AddAITemplates";
import CoachingTrack from "../pages/CoachingTrack";
import SingleRoadmapAdminView from "../pages/SingleRoadmapAdminView";
import RoadmapManagement from "../pages/RoadmapManagement";
import ProductPurchaseTracking from "../pages/ProductPurchaseTracking";
import LeadMangets from "../pages/LeadMangets";


const AdminRoutes = [
  {
    path: "/admin/home",
    exact: true,
    element: Leads,
  },
  {
    path: "/admin/videos",
    exact: true,
    element: Videos,
  },
  {
    path: "/admin/magnets-videos",
    exact: true,
    element: MegnetsVideos,
  },
  {
    path: "/admin/sections",
    exact: true,
    element: Sections,
  },

  {
    path: "/admin/rewards",
    exact: true,
    element: Rewards,
  },
  {
    path: "/admin/allquestions",
    exact: true,
    element: AllQuestions,
  },
  {
    path: "/admin/quizes",
    exact: true,
    element: Quizes,
  },
  {
    path: "/admin/modules",
    exact: true,
    element: Modules,
  },
  {
    path: "/admin/manage-price",
    exact: true,
    element: ManagePrice,
  },
  {
    path: "/admin/user-stats",
    exact: true,
    element: UserStats,
  },
  {
    path: "/admin/discounted-users",
    exact: true,
    element: DiscountedUsers,
  },
  {
    path: "/admin/finance",
    exact: true,
    element: FinanceInsights,
  },
  {
    path: "/admin/track-lead",
    exact: true,
    element: TrackLead,
  },
  // {
  //   path: "/admin/coupons",
  //   exact: true,
  //   element: Coupons,
  // },
  {
    path: "/admin/checkout-discount-links",
    exact: true,
    element: CheckoutDiscountLink,
  },
  {
    path: "/admin/paypal-discount-links",
    exact: true,
    element: PaypalDiscountLink,
  },
  {
    path: "/admin/manage-users",
    exact: true,
    element: ManageUsers,
  },
  {
    path: "/admin/deposits",
    exact: true,
    element: DepositsTracking,
  },
  {
    path: "/admin/kanban",
    exact: true,
    element: Kanban,
  },
  {
    path: "/admin/add-agent-template",
    exact: true,
    element: AITemplatesView,
  },
  {
    path: "/admin/source-aquisition",
    exact: true,
    element: SourceAcquisition,
  },
  {
    path: "/admin/sales-by-commercials",
    exact: true,
    element: SalesByCommercial,
  },
  {
    path: "/admin/masterclass-stats",
    exact: true,
    element: MasterclassStats,
  },
  {
    path: "/admin/masterclass-users",
    exact: true,
    element: MasterclassUsers,
  },
  {
    path: "/admin/ai-tools-list",
    exact: true,
    element: AIToolsTable,
  },
  {
    path: "/admin/ai-prompts-list",
    exact: true,
    element: AddAIPrompts,
  },
  {
    path: "/admin/coaching-flow",
    exact: true,
    element: CoachingTrack,
  },
  {
    path: "/admin/coaching-flow/:studentId",
    exact: true,
    element: SingleRoadmapAdminView,
  },
  {
    path: "/admin/coaching-flow-management",
    exact: true,
    element: RoadmapManagement,
  },
   {
    path: "/admin/product-purchases",
    exact: true,
    element: ProductPurchaseTracking,
  },
   {
    path: "/admin/lead-magnet",
    exact: true,
    element: LeadMangets,
  },
];

export default AdminRoutes;
